import React, { lazy } from 'react';
import { componentLoader } from 'utils/componentLoader';

const StaticPage = lazy(() => componentLoader(() => import(/* webpackChunkName: "StaticPage" */ 'components/StaticPage')));

export default ({ slug, pageTitle }) => () => (
  <StaticPage slug={slug} pageTitle={pageTitle} />
);
